export const globalStyles = {
    tableOverlay: {
        "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
            },
        },
    }
}